import { render, staticRenderFns } from "./PDPCommentTabs.vue?vue&type=template&id=1713a884&scoped=true&lang=html&"
import script from "./PDPCommentTabs.vue?vue&type=script&lang=js&"
export * from "./PDPCommentTabs.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentTabs.vue?vue&type=style&index=0&id=1713a884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713a884",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PDPFilter: require('/app/appsumo/nuxt/components/pdp/discussion/PDPFilter.vue').default,PDPComment: require('/app/appsumo/nuxt/components/pdp/comment/PDPComment.vue').default,PDPEmptyStateCard: require('/app/appsumo/nuxt/components/pdp/PDPEmptyStateCard.vue').default})
